// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Bfr_","cell":"ColumnAccessor_cell__2ZRJQ","firstCellAccent":"ColumnAccessor_firstCellAccent__3u86U"};